import React from 'react';

import { API_getPaymentStagesEditAndDeleteUrl } from '../../utils/api';

import DeleteModalConstructor from '../Forms/DeleteModalConstructor';

const ConfirmDeletePaymentStage = ({ hideModal, data }) => {
  const itemId = data.id.value;

  const deleteModalProps = {
    hideModal,

    DELETE_REQUEST_URL: API_getPaymentStagesEditAndDeleteUrl(itemId),
    DELETE_STATIC_HINT: 'Вы уверены, что хотите удалить этап платежа',
    DELETE_STATIC_VALUE: data.name.value,
  };

  return <DeleteModalConstructor {...deleteModalProps} />
};

export default ConfirmDeletePaymentStage;